import React, { Component } from 'react';
import GalleryImage from './GalleryImage/GalleryImage';
import {applicationModes} from '../constants';

let imageDescriptors = {

  default: {
    image1: {
      transformation: { dpr: 'auto', aspect_ratio: '330:210', width: 'auto', crop: 'fill', gravity: 'faces', effect: 'sharpen:200' },
      description: '<ul><li>Resize and crop the image to the relevant size</li><li>Focus on automatically detected faces</li><li>Sharpen the image</li></ul>'
    },
    image2: {
      transformation: { dpr: 'auto', aspect_ratio: '368:140', width: 'auto', crop: 'fill', gravity: 'faces', effect: 'sepia' },
      description: '<ul><li>Resize and crop the image to the relevant size</li><li>Focus on automatically detected faces</li><li>Apply a sepia effect</li></ul>'
    },

    image3: {
      transformation: { dpr: 'auto', aspect_ratio: '330:140', width: 'auto', crop: 'fill', gravity: 'faces', effect: 'blue:100' },
      description: '<ul><li>Crop the image to a different aspect ratio, focusing on auto-detected faces</li><li>Increase the intensity of the blue channel</li></ul>'
    },
    image4: {
      transformation: { dpr: 'auto', aspect_ratio: '330:210', width: 'auto', crop: 'thumb', gravity: 'auto' },
      description: '<p>Create a thumbnail dynamically.</p><ul><li>Focus on the auto-detected area of interest</li><li>Crop and resize the image to the desired dimensions</li></ul>'
    }
  },
  ga: {
    image1: {
      transformation: { dpr: 'auto', aspect_ratio: '330:210', width: 'auto', crop: 'fill', gravity: 'auto' },
      description: '<ul><li>Resize and crop the image to the relevant size</li><li>Focus on automatically detected areas of interest</li></ul>'
    },
    image2: {
      transformation: { dpr: 'auto', aspect_ratio: '368:140', width: 'auto', crop: 'fill', gravity: 'auto' },
      description: '<p>Create a thumbnail dynamically.</p><ul><li>Focus on the auto-detected area of interest</li><li>Crop and resize the image to the desired dimensions</li></ul>'
    },

    image3: {
      transformation: { dpr: 'auto', aspect_ratio: '330:140', width: 'auto', crop: 'fill', gravity: 'auto' },
      description: '<ul><li>Crop the image to a different aspect ratio, focusing on auto-detected areas of interest</li></ul>'
    },
    image4: {
      transformation: { dpr: 'auto', aspect_ratio: '330:210', width: 'auto', crop: 'thumb', gravity: 'auto' },
      description: '<p>Create a thumbnail dynamically.</p><ul><li>Focus on the auto-detected area of interest</li><li>Crop and resize the image to the desired dimensions</li></ul>'
    }
  }
};


export default class GallerySmall extends Component {
  render() {
    let desc = imageDescriptors[this.props.applicationMode] || imageDescriptors[applicationModes.DEFAULT];

    return (
      <div style={{ position: 'relative' }} className="gallery-small">
        <div style={{ position: 'relative' }}>
          <GalleryImage {...this.props} format="jpg" transformation={desc.image1.transformation} style={{ width: '38%', top: 0, bottom: 0, left: '0%' }} >
            <div dangerouslySetInnerHTML={{ __html: desc.image1.description }} />
          </GalleryImage>
          <GalleryImage {...this.props} className="primary" format="jpg" transformation={desc.image2.transformation} style={{ width: '62%', left: '38%', height: '25vw' }} >
            <div dangerouslySetInnerHTML={{ __html: desc.image2.description }} />
          </GalleryImage>
        </div>
        <div style={{ position: 'relative' }}>
          <GalleryImage {...this.props} className="primary" format="jpg" transformation={desc.image3.transformation} style={{ width: '62%', left: 0, height: '25vw' }} >
            <div dangerouslySetInnerHTML={{ __html: desc.image3.description }} />
          </GalleryImage>
          <GalleryImage {...this.props} format="jpg" transformation={desc.image4.transformation} style={{ width: '38%', top: 0, bottom: 0, left: '62%' }} >
            <div dangerouslySetInnerHTML={{ __html: desc.image4.description }} />
          </GalleryImage>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/components/GallerySmall.js
 **/